import { JSX, ReactNode, createContext, useContext, useEffect } from 'react';
import { SubmitUserSettingsRequest, UserSettingsResponse, UserSetting } from 'vopay';
import useUserSettings, { DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY } from '@/hooks/useApi/useUserSettings';
import i18n from '@/i18n/i18n';

type UserSettings = {
  userSettings: UserSetting;
  submitUserSettings: (userSettings: SubmitUserSettingsRequest) => Promise<UserSettingsResponse>;
};

export const UserSettingsContext = createContext<UserSettings>({
  userSettings: {
    timezone: 'UTC',
    SubAccountBalanceDisplay: DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY,
    Language: undefined,
  },
  submitUserSettings: async () => ({
    Success: false,
    ErrorMessage: '',
    Username: '',
    Settings: {
      timezone: 'UTC',
      SubAccountBalanceDisplay: DEFAULT_SUB_ACCOUNT_BALANCE_DISPLAY,
      Language: undefined,
    },
  }),
});

export const UserSettingsProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const { userSettings, submitUserSettings } = useUserSettings();

  useEffect(() => {
    if (userSettings.Language) {
      i18n.changeLanguage(userSettings.Language.toLowerCase());
    }
  }, [userSettings.Language]);

  return (
    <UserSettingsContext.Provider
      value={{
        userSettings,
        submitUserSettings,
      }}
    >
      {children}
    </UserSettingsContext.Provider>
  );
};

export const useUserSettingsProvider = (): UserSettings => useContext(UserSettingsContext);
